var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnquiries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_560",
    "data-name": "Group 560",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12703",
    "data-name": "Path 12703",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12704",
    "data-name": "Path 12704",
    d: "M7.664,25.149a1.3,1.3,0,0,1-.5-.1,1.287,1.287,0,0,1-.791-1.189v-2a.79.79,0,0,0-.79-.79,2.335,2.335,0,0,1-2.332-2.332V7.545A2.335,2.335,0,0,1,5.585,5.213H23.113a2.334,2.334,0,0,1,2.332,2.332V18.738a2.334,2.334,0,0,1-2.332,2.332H12.666a.79.79,0,0,0-.554.226L8.567,24.779a1.288,1.288,0,0,1-.9.37M5.585,6.755a.79.79,0,0,0-.79.79V18.738a.79.79,0,0,0,.79.79,2.335,2.335,0,0,1,2.332,2.332v1.4l3.115-3.06a2.318,2.318,0,0,1,1.634-.668H23.113a.79.79,0,0,0,.79-.79V7.545a.79.79,0,0,0-.79-.79Z",
    transform: "translate(0.651 1.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12705",
    "data-name": "Path 12705",
    d: "M15.255,8.455a2.725,2.725,0,0,1,.854,2.106.125.125,0,0,0,0,.03,2.533,2.533,0,0,1-.869,2.075L15.2,12.7a3.68,3.68,0,0,1-1.939.69.444.444,0,0,0-.418.419l-.014.259a.443.443,0,0,1-.443.42h-.522a.443.443,0,0,1-.443-.43l-.041-1.289a.443.443,0,0,1,.443-.458,4.668,4.668,0,0,0,2.023-.347l.062-.03a1.39,1.39,0,0,0,.683-1.356,1.541,1.541,0,0,0-.4-1.128.5.5,0,0,0-.044-.043A1.6,1.6,0,0,0,13,9.01a1.665,1.665,0,0,0-1.156.383c-.014.013-.03.026-.043.041a1.453,1.453,0,0,0-.385.742.444.444,0,0,1-.436.36h-.594a.441.441,0,0,1-.439-.5,2.923,2.923,0,0,1,.338-.976,2.557,2.557,0,0,1,1.075-1.012,3.5,3.5,0,0,1,1.628-.361,3.234,3.234,0,0,1,2.268.773m-3.874,8.8a1.012,1.012,0,0,1,.721-1.733.961.961,0,0,1,.707.292,1.036,1.036,0,0,1,0,1.441.961.961,0,0,1-.707.292.98.98,0,0,1-.724-.292Z",
    transform: "translate(1.988 1.536)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnquiries);
export default __webpack_public_path__ + "static/media/icon-enquiries.612824984d1aeb4ff5233e7620a7a1cf.svg";
export { ForwardRef as ReactComponent };